import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FtpUserCreateDTO,
  FtpUser,
  FtpUserID,
  FtpUserUpdateDTO,
  FtpUserSearchResult,
  FtpUserWithLogs,
  FtpUserToggleDTO,
} from '../../shared/models/ftp-users.models';

@Injectable({
  providedIn: 'root',
})
export class FtpUsersService {
  private http = inject(HttpClient);

  createFtpUser(dto: FtpUserCreateDTO): Observable<FtpUser> {
    return this.http.post<FtpUser>('/ftp/ftp-users', dto);
  }

  updateFtpUser(id: FtpUserID, dto: FtpUserUpdateDTO): Observable<void> {
    return this.http.patch<void>(`/ftp/ftp-users/${id}`, dto);
  }

  toggleFtpUser(id: FtpUserID, dto: FtpUserToggleDTO): Observable<void> {
    return this.http.patch<void>(`/ftp/ftp-users/${id}/toggle`, dto);
  }

  deleteFtpUser(id: FtpUserID): Observable<void> {
    return this.http.delete<void>(`/ftp/ftp-users/${id}`);
  }

  searchFtpUsers(page: number, search?: string): Observable<FtpUserSearchResult> {
    page = page < 1 ? 1 : page;

    const searchParams = new URLSearchParams();
    searchParams.append('page', page.toString());

    if (search) searchParams.append('search', search);

    return this.http.get<FtpUserSearchResult>(`/ftp/ftp-users?${searchParams.toString()}`);
  }

  findOneById(id: FtpUserID): Observable<FtpUserWithLogs> {
    return this.http.get<FtpUserWithLogs>(`/ftp/ftp-users/${id}`);
  }
}
